import { Button } from "../button/button";

import styles from "./scrollableMenu.module.css"

export const ScrollableMenu = ({ buttons, current, setCurrent }) => {
    return (
        <div className={styles.scrollable_menu}>
            <div className={styles.scrollable_menu_container}>
                {
                    buttons.map((item) => (
                        <div key={item.id} className={styles.scrollable_menu_item} onClick={() => setCurrent(item.id)}>
                                <Button
                                    type={current === item.id ? "primary" : "secondary"}
                                    text={item.text}
                                    view="thin"
                                />
                        </div>
                    ))
                }
            </div>
        </div>
    );
}